export default __webpack_public_path__ + "static/media/arma2.da693630.png";